"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var image_1 = __importDefault(require("next/image"));
var react_1 = __importDefault(require("react"));
var BonusImg_1 = __importDefault(require("./BonusImg"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var GetBonusPanel = function (_a) {
    var _b, _c, _d;
    var _e = _a.firstBonus, firstBonus = _e === void 0 ? false : _e, _f = _a.showSignUp, showSignUp = _f === void 0 ? true : _f;
    var t = (0, next_intl_1.useTranslations)('translation');
    var bonusData = (0, swr_hooks_1.useCalculateWelcomePackage)();
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var signUpNavigate = (0, apps_shared_1.useOpenSignUp)();
    if (isAuth || Object.keys(breakpoints).length === 0 || breakpoints.mobile)
        return null;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", null,
            react_1.default.createElement(BonusImg_1.default, null),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.text },
                bonusData.percent && bonusData.freeSpins ? (react_1.default.createElement("div", { dangerouslySetInnerHTML: {
                        __html: t('getBonusPanelText', {
                            percents: bonusData.percent,
                            freespins: bonusData.freeSpins,
                        }),
                    } })) : null,
                ((bonusData === null || bonusData === void 0 ? void 0 : bonusData.affBonus) && bonusData.percent && !bonusData.freeSpins) ||
                    bonusData.freeSpins === 0 ? (react_1.default.createElement("div", { dangerouslySetInnerHTML: {
                        __html: t('getBonusPanelTextOnlyPercents', {
                            percents: firstBonus
                                ? "".concat((_d = (_c = (_b = bonusData === null || bonusData === void 0 ? void 0 : bonusData.first) === null || _b === void 0 ? void 0 : _b.rewards) === null || _c === void 0 ? void 0 : _c.find(function (r) { return !!(r === null || r === void 0 ? void 0 : r.relativePercent); })) === null || _d === void 0 ? void 0 : _d.relativePercent, "%")
                                : bonusData.percent,
                        }),
                    } })) : null,
                (bonusData === null || bonusData === void 0 ? void 0 : bonusData.affBonus) &&
                    (!bonusData.percent || bonusData.percent === 0) &&
                    bonusData.freeSpins && (react_1.default.createElement("div", { dangerouslySetInnerHTML: {
                        __html: t('getBonusPanelTextOnlyFS', {
                            freespins: bonusData.freeSpins,
                        }),
                    } })))),
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: styles_module_scss_1.default.plus18 },
                react_1.default.createElement(image_1.default, { width: 30, height: 30, src: "/img/getBonusPanel/plus18.svg", alt: "18 plus" })),
            showSignUp && (react_1.default.createElement(ui_components_1.FixedButton, { width: "250px", color: "gradient", text: "upper", onClick: signUpNavigate }, t('signup'))))));
};
exports.default = GetBonusPanel;
